import { IFilter } from '../../types/advancedFilters';
import { SuburbanFacilitiesContainer } from '../../containers/advancedFilters/SuburbanFacilitiesContainer';

export const suburbanFacilities: IFilter = {
  component: SuburbanFacilitiesContainer,
};
